/* Shared, source-owned catalogue helpers for the storefront entrance. */
(function (global) {
  'use strict';
  const key = value => String(value || '').normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/ß/g, 'ss').replace(/[^a-z0-9]/g, '');
  const aliases = { Bremsbelag: ['bremsbeläge', 'bremsbelaege'], Schlauch: ['schläuche', 'schlaeuche'], Ladegerät: ['ladegeräte', 'ladegeraete'] };
  function models(vehicles, brandId) { return vehicles.filter(v => v.brandId === brandId); }
  function suggestions(query, groups, vehicles) {
    const q = key(query);
    if (q.length < 2) return [];
    const entries = [];
    for (const group of groups) {
      if (key(group.label).includes(q)) entries.push({ kind: 'category', label: group.label, handle: group.handle, query: '' });
      for (const type of group.types) {
        if ([type.label, ...(type.aliases || []), ...(aliases[type.label] || [])].some(label => key(label).includes(q))) {
          if (!entries.some(e => key(e.label) === key(type.label))) entries.push({ kind: 'part', label: type.label, handle: group.handle, query: type.label });
        }
      }
    }
    const exact = entries.filter(e => key(e.label) === q);
    const parts = [...exact, ...entries.filter(e => !exact.includes(e))].slice(0, 6);
    const found = vehicles.filter(v => [v.label, ...(v.aliases || [])].some(label => key(label).includes(q))).slice(0, parts.length ? 2 : 6);
    return [...parts, ...found.map(v => ({ kind: 'vehicle', label: v.label, vehicle: v.id }))];
  }
  const api = { key, models, suggestions };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.EsvPartsCatalog = api;
})(typeof window === 'undefined' ? globalThis : window);
